import { useCallback, useEffect, useState } from "react";
// https://feathersjs.com/guides/cli/client#usage
import app from "../../../global-account/app.js";
export function useQueryB3(service,
// Service as string
method,
// Method as string
params,
// Params type inferred dynamically
fetchInitially = true) {
  // Use DataType to infer the type of data and unwrap the Promise
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const runQuery = useCallback(async queryParams => {
    setIsLoading(true);
    try {
      // Cast the service to avoid TypeScript issues with dynamic services
      const serviceInstance = app.service(service);
      const result = await serviceInstance[method](queryParams);
      setData(result); // Now `data` is correctly typed!
      return result;
    } catch (err) {
      setError(err instanceof Error ? err : new Error("An error occurred"));
    } finally {
      setIsLoading(false);
    }
  }, [service, method]);
  // Serialize params for stable comparison
  const paramsJson = JSON.stringify(params);
  useEffect(() => {
    if (fetchInitially) {
      runQuery(params);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [runQuery, fetchInitially, paramsJson]);
  return {
    data,
    error,
    isLoading,
    runQuery
  };
}